module.exports = __webpack_public_path__ + "img/10.2958e3a8.jpg";